module.exports = __webpack_public_path__ + "img/henkel-belenes.30fb6305.jpg";